export default "__VITE_ASSET__BaoES5G0__"